import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const services = [
  {
    title: "Doğalgaz Tesisatı",
    description: "Konut ve iş yerleriniz için güvenli ve standartlara uygun doğalgaz tesisatı kurulumu ve dönüşümü.",
    icon: "🔥" // Placeholder icon
  },
  {
    title: "Isıtma Sistemleri",
    description: "Yüksek verimli kombi, kazan ve merkezi ısıtma sistemleri ile sıcak ve konforlu mekanlar.",
    icon: "♨️" // Placeholder icon
  },
  {
    title: "Panel Çit",
    description: "Güvenli ve estetik panel çit çözümleriyle alanlarınızı koruma altına alın.",
    icon: "🥅" // Placeholder icon
  },
  {
    title: "Sıhhi Tesisat",
    description: "Temiz ve atık su sistemlerinizin projelendirilmesi, kurulumu ve bakımı.",
    icon: "💧" // Placeholder icon
  },
  {
    title: "Yangın Tesisatı",
    description: "Yangın güvenliği standartlarına uygun, güvenilir sulu ve kuru tip yangın söndürme sistemleri.",
    icon: "🧯" // Placeholder icon
  },
  {
    title: "Endüstriyel Tesisat",
    description: "Fabrika ve üretim tesisleri için özel ihtiyaçlara yönelik endüstriyel tesisat çözümleri.",
    icon: "🏭" // Placeholder icon
  }
];

const Services: React.FC = () => {
  return (
    <Container>
      <Row className="text-center mb-5">
        <Col>
          <h2 className="display-5 fw-bold">Faaliyet Alanlarımız</h2>
          <p className="lead text-muted">Profesyonel çözümler sunduğumuz ana hizmet başlıkları.</p>
        </Col>
      </Row>
      <Row>
        {services.map((service, index) => (
          <Col md={4} className="mb-4" key={index}>
            <Card className="h-100 text-center shadow-sm border-0">
              <Card.Body className="p-4">
                <div className="display-4 text-primary mb-3">{service.icon}</div>
                <Card.Title as="h4" className="fw-bold mb-3">{service.title}</Card.Title>
                <Card.Text className="text-muted">
                  {service.description}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Services;